module.exports = __webpack_public_path__ + "static/zendesk-81c34f56495ca3db9f64347374f9570c.svg";